var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.28125H5.78125C6.05737 6.28125 6.28125 6.05737 6.28125 5.78125V0.5C6.28125 0.223877 6.05737 0 5.78125 0H3.5C1.57007 0 0 1.57007 0 3.5V5.78125C0 6.05737 0.223877 6.28125 0.5 6.28125ZM1 3.5C1 2.12158 2.12158 1 3.5 1H5.28125V5.28125H1V3.5Z",
    fill: "#EF7C32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0H8.21875C7.94263 0 7.71875 0.223877 7.71875 0.5V5.78125C7.71875 6.05737 7.94263 6.28125 8.21875 6.28125H13.5C13.7761 6.28125 14 6.05737 14 5.78125V3.5C14 1.57007 12.4299 0 10.5 0ZM13 5.28125H8.71875V1H10.5C11.8784 1 13 2.12158 13 3.5V5.28125Z",
    fill: "#EF7C32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 13.9999H5.78125C6.05737 13.9999 6.28125 13.776 6.28125 13.4999V8.21863C6.28125 7.9425 6.05737 7.71863 5.78125 7.71863H0.5C0.223877 7.71863 0 7.9425 0 8.21863V10.4999C0 12.4298 1.57007 13.9999 3.5 13.9999ZM1 8.71863H5.28125V12.9999H3.5C2.12158 12.9999 1 11.8783 1 10.4999V8.71863Z",
    fill: "#EF7C32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.71863H8.21875C7.94263 7.71863 7.71875 7.9425 7.71875 8.21863V13.4999C7.71875 13.776 7.94263 13.9999 8.21875 13.9999H10.5C12.4299 13.9999 14 12.4298 14 10.4999V8.21863C14 7.9425 13.7761 7.71863 13.5 7.71863ZM13 10.4999C13 11.8783 11.8784 12.9999 10.5 12.9999H8.71875V8.71863H13V10.4999Z",
    fill: "#EF7C32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfig);
export default __webpack_public_path__ + "static/media/config.8cb1156f2c1b52f2ddf61e0b2bd2652a.svg";
export { ForwardRef as ReactComponent };